var map = {
	"./Architecture.pdf": 59195,
	"./Artificial Intelligence and Data Science.pdf": 70142,
	"./Artificial Intelligence and Machine Learning.pdf": 92323,
	"./Chemical Engineering.pdf": 81899,
	"./Chemistry.pdf": 70552,
	"./Civil Engineering.pdf": 60498,
	"./Computer Science and Design.pdf": 7170,
	"./Computer Science and Engineering.pdf": 11717,
	"./Computer Technology (PG) - M.Sc Software Systems (5Years Integrated) .pdf": 40665,
	"./Computer Technology (UG) - B.Sc(CSD, IS, SS).pdf": 1000,
	"./EEE.pdf": 68881,
	"./Electronics and Communication Engineering.pdf": 17413,
	"./Electronics and Instrumentation Engineering.pdf": 33207,
	"./Food Technology.pdf": 94444,
	"./Information Technology.pdf": 68826,
	"./Master of Business Administration .pdf": 9497,
	"./Master of Computer Applications.pdf": 14643,
	"./Maths.pdf": 5039,
	"./Mechanical Engineering.pdf": 82138,
	"./Mechatronics Engineering.pdf": 50699,
	"./Physics.pdf": 37509,
	"./automobile.pdf": 11985,
	"./english.pdf": 22774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17580;